<template>
  <MonitorWrapper class="rm1000">
    <el-row :gutter="20">
      <el-col :span="24">
        <info-block :title="[deviceName, sn]">
          <template #content>
            <el-row class="rm1000-info state-block">
              <el-col :span="5">
                <ModsIcon
                  showText
                  :alarmState="alarmState"
                  :alarmDic="alarm"
                  width="120px"
                  icon="icon-he"
                  :wsData="wsData"
                  :mods="curMod"
                />
              </el-col>
              <el-col :span="4">
                <!-- <div>
                  <span>{{ $t('核素名称') }}:</span>
                  <span>{{ nuclideName }}</span>
                </div> -->

                <div>
                  <span>{{ $t('报警状态') }}:</span>
                  <span :style="{ color: alarmColor }" v-if="rm1000">
                    {{ alarmState | alarmText | translateTo(i18nPath) }}
                  </span>
                  <span v-else>未连接</span>
                </div>
                <div>
                  <span>{{ $t('射线实时数') }}(CPS):</span>
                  <span>{{ realValue }}</span>
                </div>
                <div>
                  <span>{{ $t('剂量率') }}:</span>
                  <span>{{ doseRate }} uSv/h</span>
                </div>
              </el-col>
              <el-col :span="15">
                <div class="activity-box">
                  <el-table :data="tableData" style="width: 100%">
                    <el-table-column prop="name" label="物质名称"></el-table-column>
                    <el-table-column prop="time" label="时间"></el-table-column>

                    <el-table-column label="操作">
                      <!--        :disabled="scope.row.disabled" -->
                      <template slot-scope="scope">
                        <el-button @click="showChartHandle(scope.row)" type="text" size="small">
                          查看活度数值
                        </el-button>
                      </template>
                    </el-table-column>
                  </el-table>
                </div>
              </el-col>
            </el-row>
            <div class="rm1000-chart" style="overflow: hidden">
              <v-chart :options="cpsChartOpt" :autoresize="true"></v-chart>
            </div>
          </template>
        </info-block>
      </el-col>
    </el-row>

    <el-dialog
      v-if="chartVisable"
      title="活度数值"
      :visible.sync="chartVisable"
      width="60%"
      show-close
    >
      <div style="width: 100%; height: 300px">
        <v-chart
          style="height: 100%; width: 100%"
          :options="dialogChartData"
          :autoresize="true"
        ></v-chart>
      </div>
    </el-dialog>
  </MonitorWrapper>
</template>

<script>
import { mapState } from 'vuex';
import InfoBlock from '../components/info-block';
import { formatTime } from '@/utils/date';

import { lineAreaStyle } from '@/echartOption/lineAreaStyle';
import { graColor } from '@/views/realdata/FCBR-100/options';
import ModsIcon from '@/components/mods-icon';
import monitorMixin from '@/mixins/monitorMixin';
import { popRG05Setting, popRG05NuclideSetting } from '@/layout/mainHeader/util';
import { setDeviceAnalogAarm } from '@/layout/commonActions/setDeviceAnalogAarm';

const _generateMockDataArray = () => {
  const arr = [];
  for (let i = 0; i < 32; i++) {
    const randomNum = Math.floor(Math.random() * Number.MAX_SAFE_INTEGER) + 1;
    arr.push(randomNum);
  }
  return arr;
};

export default {
  name: 'RM1000',
  components: {
    InfoBlock,
    ModsIcon
  },
  mixins: [monitorMixin],
  filters: {
    alarmText(state) {
      const dict = ['正常', '报警', '报警', '报警', '报警'];
      return dict[state] || '';
    }
  },
  data() {
    return {
      i18nPath: 'device',
      alarm: ['正常', '报警', '报警', '报警', '报警'],
      rm1000: null,
      nuclideTimer: null,
      delay: 10000,
      cpsChartOpt: lineAreaStyle({
        legend: {
          right: 10,
          orient: 'vertical',
          align: 'left',
          icon: 'rect',
          textStyle: {
            color: '#fff'
          }
        },
        yAxis: { name: '剂量率(uSv/h)' },
        color: ['#06c9c3', '#7a17c7'],
        series: [
          {
            name: '剂量率(uSv/h)',
            areaStyle: { color: graColor('rgba(6, 201, 195, .8)', 'rgba(6, 201, 195, 0.1)') }
          }
        ]
      }),
      wsData: {},
      curMod: 'nuclearMod',
      dataSeries: [],
      activityChartOpt: {
        tooltip: {
          trigger: 'axis',
          axisPointer: { type: 'shadow' },
          valueFormatter: value => value?.toFixed(2),
          position: function (point, params, dom, rect, size) {
            const x = point[0] + 10;
            // const y = point[1] - 30;
            const posX =
              x + size.contentSize[0] > size.viewSize[0] ? x - size.contentSize[0] - 10 : x;
            // const posY =
            //   y + size.contentSize[1] > size.viewSize[1] ? y - size.contentSize[1] - 10 : y;
            return [posX, 0];
          }
        },
        legend: {
          type: 'scroll',
          orient: 'horizontal',
          left: 'center',
          top: 12,
          icon: 'circle',
          textStyle: { fontSize: 11 },
          data: []
        },
        grid: {
          left: '8%',
          right: '8%',
          bottom: '15%',
          top: '20%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          name: '采样点',
          boundaryGap: false,
          data: Array.from({ length: 32 }, (_, i) => i),
          axisLabel: { rotate: 0, interval: 'auto' },
          axisLine: {
            lineStyle: {
              color: '#00A0E9'
            }
          },
          splitLine: { show: false }
        },
        yAxis: {
          type: 'value',
          name: '活度数值',
          scale: true,
          axisLabel: { fontSize: 11 },
          axisLine: {
            lineStyle: {
              color: '#00A0E9'
            }
          },
          splitLine: { show: false }
        },
        series: []
      },
      chartVisable: false,
      tableData: [],
      dialogChartData: null
    };
  },
  computed: {
    ...mapState('history', ['historyDetailData', 'historyDetailDatas']),
    alarmState() {
      return this.rm1000 ? this.rm1000.alarmState : 0;
    },
    nuclideName() {
      return this.rm1000 && this.rm1000.nuclideName.length
        ? this.rm1000.nuclideName.join(',')
        : '--';
    },

    alarmColor() {
      return this.alarmState !== 0 ? '#FF4847' : '#03b36e';
    },
    realValue() {
      return this.rm1000 ? this.rm1000.cpsValue : 0;
    },
    bgroundValue() {
      return this.rm1000 ? this.rm1000.cpsBaselineValue : 0;
    },

    doseRate() {
      return this.rm1000 ? this.rm1000.radDose : 0;
    },
    deviceName() {
      return this.deviceSNMap[this.sn]?.name;
    },

    authMenu() {
      return this.$store.state.admin.authMenu;
    }
  },
  methods: {
    langChangeHandler() {
      this.cpsChartOpt.series[0].name = this.$t('剂量率(uSv/h)');
    },
    toSetting() {
      popRG05Setting({ sn: this.sn, deviceType: this.deviceType });
    },
    setDeviceAnalogAarm() {
      setDeviceAnalogAarm({ container: this.$el, sn: this.sn, deviceType: this.deviceType });
    },
    toNuclideSetting() {
      popRG05NuclideSetting({ sn: this.sn, deviceType: this.deviceType });
    },
    updateData(newVal) {
      const { beginTime } = newVal;
      const { rm1000Dto } = newVal.mods[this.curMod];

      if (!rm1000Dto) {
        clearTimeout(this.nuclideTimer);
        this.nuclideTimer = setTimeout(() => {}, this.delay);

        return;
      }

      this.wsData = newVal;

      this.rm1000 = rm1000Dto;
      this.rm1000.alarmState = newVal.state;
      this.cpsChartOpt.series[0].data.push([beginTime, rm1000Dto.radDose]);
      this.addNewDataPoint({ time: beginTime, arr: rm1000Dto.activityValue });

      //   this.addNewDataPoint({ time: Date.now(), arr: generateMockDataArray(Date.now() % 10000) });

      if (this.cpsChartOpt.series[0].data.length > 20) {
        this.cpsChartOpt.series[0].data.shift();
      }
    },
    updateHisData() {
      this.historyDetailDatas.slice(-20).forEach(val => {
        this.updateData(val);
      });
      clearTimeout(this.nuclideTimer);
      this.wsData = this.historyDetailData;
      this.rm1000 = this.historyDetailData.mods[this.curMod].rg05;
      this.hideLoading();
    },

    addNewDataPoint(dataPackage) {
      const timeStr = formatTime(dataPackage.time, 'hh:mm:ss');
      const showChartBtn = dataPackage.arr.every(value => value > 0);

      const legendData = [
        {
          name: timeStr,
          textStyle: {
            fontWeight: 'bold',
            color: 'F56C6C',
            fontSize: 11
          },
          icon: 'circle'
        }
      ];
      const seriesList = [
        {
          name: timeStr,
          type: 'line',
          data: dataPackage.arr.slice(),
          smooth: false,
          symbol: 'circle',
          symbolSize: 3,
          lineStyle: {
            width: 4,
            color: '#F56C6C',
            type: 'solid',
            opacity: 1,
            shadowBlur: 6,
            shadowColor: 'rgba(245,108,108,0.5)'
          },
          areaStyle: { opacity: 0.12, color: '#F56C6C' },
          emphasis: { focus: 'series' },
          z: 10
        }
      ];

      this.activityChartOpt.legend.data = legendData;
      this.activityChartOpt.series = seriesList;

      const chartDataCopy = JSON.parse(
        JSON.stringify({
          legend: { data: legendData },
          series: seriesList,
          tooltip: this.activityChartOpt.tooltip,
          grid: this.activityChartOpt.grid,
          xAxis: this.activityChartOpt.xAxis,
          yAxis: this.activityChartOpt.yAxis
        })
      );

      this.tableData.push({
        name: this.nuclideName,
        time: formatTime(dataPackage.time, 'yyyy-MM-dd hh:mm:ss'),
        disabled: !showChartBtn,
        chartData: chartDataCopy
      });

      if (this.tableData.length > 6) {
        this.tableData.shift();
      }
    },

    showChartHandle(e) {
      this.dialogChartData = e.chartData;
      this.chartVisable = true;
    }
  },
  created() {
    this.langChangeHandler();
  }
};
</script>

<style lang="scss" scoped>
.rm1000 {
  height: 100%;

  .battery-alarm {
    color: $danger-color;
  }

  .el-row {
    height: 100%;
    .el-col {
      height: 100%;
      .rm1000-info {
        height: 35%;
        &.state-block {
          .el-col {
            height: 100%;
            display: flex;
            justify-content: center;
            align-items: center;
            &:nth-child(2) {
              flex-direction: column;
              justify-content: center;
              align-items: flex-start;
              font-size: 18px;
              line-height: 34px;

              div {
                span:nth-of-type(1) {
                  margin-right: 8px;
                }
              }
            }
            .activity-box {
              @include scrollar-style-bold;
              height: 100%;
              width: 100%;
              padding: 10px;
              box-sizing: border-box;
              overflow-y: auto;
              &-info {
                margin-bottom: 20px;
                &-title {
                  font-weight: bold;
                  color: #fff;
                  margin-bottom: 20px;
                }
                &-detail {
                  display: grid;
                  grid-template-columns: repeat(4, 1fr);
                  grid-gap: 10px;
                  .activity-card {
                    /* font-weight: bold; */
                    color: #fff;
                  }
                }
              }
            }
          }
        }
      }
      .rm1000-chart {
        height: 65%;
      }
    }
  }
  .state {
    @include state-textstyle;
  }
}
</style>
